import { ModalFooter, ModalFooterButton } from '@/components/Modal'

import { useControllerActions } from '../../hooks/useControllerActions'
import { useController } from '../../hooks/useController'

import { useTexts } from './useTexts'

export function Footer() {
  const texts = useTexts()
  const actions = useControllerActions()
  const { close } = useController()

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton
          variant="contained"
          onClick={actions.sendFeedback}
          testid="modal-primary-button"
        >
          {texts.sendFeedback}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton onClick={close} testid="modal-secondary-button">
          {texts.cancel}
        </ModalFooterButton>
      }
    />
  )
}
